import React, { useEffect, useState } from 'react';
import { calendarApi } from './calendarApi';
import { formatCalendarStats, CALENDAR_FALLBACK_TAGLINE } from './calendarStatsText';

/**
 * The one live tagline, rendered identically on subscribe and on login.
 *
 * ONE COMPONENT RATHER THAN THE SAME FETCH TWICE. The two pages showed two
 * slightly different static sentences, which is how a product ends up
 * describing itself two ways; they now show the same one, and changing it is a
 * change in one file.
 *
 * NEVER BLANK AND NEVER WRONG. It renders the static tagline immediately, swaps
 * in the counts when they arrive, and keeps the tagline if the request fails or
 * the numbers are all zero. A visitor reading a signup page should not be able
 * to tell that a request happened at all.
 */
function CalendarStatsLine({ style }) {
  const [line, setLine] = useState('');

  useEffect(() => {
    let live = true;

    calendarApi('/public/stats')
      .then(stats => {
        if (live) setLine(formatCalendarStats(stats));
      })
      .catch(() => {
        // Deliberately silent. The fallback is already on the screen, and a
        // subscriber has nothing to do with a failure to count states.
      });

    return () => { live = false; };
  }, []);

  return (
    <p style={{ color: 'var(--color-text-light)', marginTop: 0, marginBottom: '24px', ...style }}>
      {line || CALENDAR_FALLBACK_TAGLINE}
    </p>
  );
}

export default CalendarStatsLine;
